import { useContext } from 'react';

import {
  BodyRow,
  BodyRowProps,
  Tooltip,
  isLoadingRow,
} from '@cast/design-system';

import { PreparedWorkload } from 'features/workload-optimization';

import { OptimizationWorkloadsListContext } from '../../../context';

export const BodyRowWithTooltip = (
  rowProps: BodyRowProps<PreparedWorkload>
) => {
  const { isManagedByAnnotations, namespace, verticalScalingPolicy } =
    rowProps.row;
  const { isNamespaceWritable } = useContext(OptimizationWorkloadsListContext);

  if (isLoadingRow(rowProps.row)) {
    return <BodyRow {...rowProps} />;
  }

  const tooltipTitle = !isNamespaceWritable(namespace)
    ? 'Restricted access to namespace'
    : isManagedByAnnotations
    ? 'The workload is managed by annotations'
    : verticalScalingPolicy?.isCastware
    ? 'Castware workload'
    : undefined;

  return (
    <Tooltip
      title={tooltipTitle}
      wrapIf={!!tooltipTitle}
      color="secondary"
      placement="top"
      followCursor
    >
      <div className={tooltipTitle ? 'disabled-row' : undefined}>
        <BodyRow {...rowProps} />
      </div>
    </Tooltip>
  );
};
